var _g, _path, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneDiversion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.396,18.525L8.357,18.563L8.356,18.566L8.396,18.525Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.002,2.475L24.002,4.08C21.202,4.155 18.067,5.067 16.202,6.462L16.202,6.462C17.118,7.554 17.606,8.93 17.708,10.374C19.037,8.949 21.933,8.103 24.002,7.963L24.002,9.543C21.157,9.745 17.824,11.471 16.613,14.15C16.412,11.214 15.732,8.244 13.795,6.257C16.344,3.995 19.92,2.652 24.002,2.475Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.573524,-0.766987,0.702157,0.525047,-4.16206,6.13627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.122,1.633L13.378,11.439L0.865,11.439L7.122,1.633Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.715469,0,0,1,3.42338,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.356,24.036L8.356,19.88C8.371,19.666 8.378,19.449 8.378,19.231L8.356,18.566L8.355,18.566C8.443,16.3 8.544,10.996 4.102,8.589L8.157,4.439C12.65,7 15.667,10.087 15.571,16.581L15.572,16.602C15.591,16.869 15.6,17.138 15.6,17.409C15.6,17.681 15.591,17.95 15.572,18.217L15.572,24.036L8.356,24.036Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneDiversion);
export default __webpack_public_path__ + "static/media/airplane-diversion.2abeb2ba.svg";
export { ForwardRef as ReactComponent };